import { navLinks } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                包
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                包子漫画
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-md">
              包子漫画排行榜汇集人气漫画推荐、分类新番与更新日历，
              帮你判断哪些是真正好看的漫画。无论追更还是补番，
              都能在这里快速找到下一部要看的作品。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["人气漫画", "分类新番", "好看的漫画", "追更补番"].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-md bg-background-50 text-xs font-label text-foreground-700"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <nav className="md:col-span-4" aria-label="页内导航">
            <h3 className="font-heading text-sm font-bold text-foreground-950">
              页内导航
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2.5 gap-x-4">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#trends"
                  className="text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  趋势解读
                </a>
              </li>
              <li>
                <a
                  href="#guide"
                  className="text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  追更指南
                </a>
              </li>
            </ul>
          </nav>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-foreground-950">
              关于榜单
            </h3>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
              榜单综合读者评分、追更人数与讨论热度滚动计算，
              排名会随口碑持续变化，并非一次性的固定评奖。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs font-label text-foreground-600">
            © 2026 包子漫画排行榜 · 本站内容为作品推荐与信息整理，页面演示数据仅供浏览参考。
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-up-line text-base" aria-hidden="true"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}